import React from 'react'
import Portal from 'components/Portal/Portal'
import './UnsupportedBrowser.scss'
import ChromeIcon from '../../common/img/browser-icons/chrome.png'
import OperaIcon from '../../common/img/browser-icons/opera.png'
import SafariIcon from '../../common/img/browser-icons/safari.png'
import EdgeIcon from '../../common/img/browser-icons/edge.png'
import FirefoxIcon from '../../common/img/browser-icons/firefox.png'
import Markdown from 'components/Markdown/Markdown'

let STATE_ABBR = process.env.STATE_ABBR;
STATE_ABBR = STATE_ABBR.toUpperCase()
let LOGO_FILENAME = process.env.LOGO_FILENAME;
let SEAL_FILENAME = process.env.SEAL_FILENAME;
const Logo = require("../../common/img/seals/" +
  STATE_ABBR +
  (LOGO_FILENAME
    ? `/${LOGO_FILENAME}`
    : SEAL_FILENAME ? `/${SEAL_FILENAME}` : "/seal.svg"))
const LOGO_ALT = process.env.LOGO_ALT || `${process.env.STATE_NAME} ${process.env.STATE_ORG_TITLE}`

const BROWSERS = [
  {
    name: "Google Chrome",
    link: "https://www.google.com/chrome/",
    icon: ChromeIcon,
    color: 'red'
  },
  {
    name: "Microsoft Edge",
    link: "https://www.microsoft.com/en-us/edge",
    icon: EdgeIcon,
    color: 'teal'
  },
  {
    name: "MacOS Safari",
    link: "https://support.apple.com/en-us/HT204416",
    icon: SafariIcon,
    color: 'blue'
  },
  {
    name: "Mozilla Firefox",
    link: "https://www.mozilla.org/en-US/firefox/new/",
    icon: FirefoxIcon,
    color: 'orange'
  },
  {
    name: "Opera",
    link: "https://www.opera.com/",
    icon: OperaIcon,
    color: 'red'
  },
]

export default () => {

  return (
    <Portal isOpened>
      <div className="unsupported-browser-wrapper" role="alert">
        <div className="inner-wrapper">
          <header>
            <img src={Logo} alt={LOGO_ALT}/>
            <div className="flex-column title-wrapper">
              <h1 className="statetitle">{process.env.STATE_NAME}</h1>
              <span className="subtext">{process.env.STATE_ORG_TITLE}</span>
            </div>
            <p>{process.env.SYSTEM_NICKNAME}</p>
          </header>
          <div className="message-wrapper">
            <p>{process.env.IE_DEPRECATED_MESSAGE}</p>
            <Markdown source={process.env.UNSUPPORTED_BROWSER_MESSAGE} />
            <div className="browser-list">
              <div className="browser-column">
                {
                  BROWSERS.slice(0, 3).map(browser => (
                    <a href={browser.link} data-hover-color={browser.color} target="_blank">
                      <img src={browser.icon} alt="" />
                      <span>{browser.name}</span>
                    </a>
                  ))
                }
              </div>
              <div className="browser-column">
                {
                  BROWSERS.slice(3, 5).map(browser => (
                    <a href={browser.link} data-hover-color={browser.color} target="_blank">
                      <img src={browser.icon} alt="" />
                      <span>{browser.name}</span>
                    </a>
                  ))
                }
              </div>
            </div>
          </div>
          <div className="unsupported-footer">
            <span>Icons by <a target="_blank" href="https://icons8.com">Icons8</a></span>
          </div>
        </div>
      </div>
    </Portal>
  )
}



// WEBPACK FOOTER //
// ./src/components/UnsupportedBrowser/UnsupportedBrowser.js